import { apiClient } from "./client";
import type { DepartmentsResponse, NafSectionsResponse } from "./types";

/** Reference list of départements for the requested country. */
export async function getDepartments(
  country: string = "FR",
): Promise<DepartmentsResponse> {
  const res = await apiClient.get<DepartmentsResponse>(
    "/references/departments",
    { params: { country } },
  );
  return res.data;
}

/** NAF 2-digit divisions for the requested country. */
export async function getNafSections(
  country: string = "FR",
): Promise<NafSectionsResponse> {
  const res = await apiClient.get<NafSectionsResponse>(
    "/references/naf-sections",
    { params: { country } },
  );
  return res.data;
}
